// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import XRegExp from 'xregexp'
import { dateFormat } from 'helpers/regex'
import { INVALID_DATE_FORMAT } from 'errors'

const validateDateFormat = v => (
  v.length && !XRegExp.exec(v, dateFormat) && INVALID_DATE_FORMAT
)

export default validateDateFormat
